import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// goods_receipts — ใบรับสินค้า (Goods Receipt / Purchase Receipt)
// ============================================================================
export const goodsReceipts = sqliteTable("inventory_goods_receipts", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  receiptNo: text("receipt_no").notNull().unique(),
  partyType: text("party_type").notNull().default("supplier"), // supplier, customer, etc.
  partyId: text("party_id").notNull(),
  warehouseId: text("warehouse_id").notNull(),
  postingDate: text("posting_date").notNull(),
  remarks: text("remarks"),
  docStatus: integer("doc_status").notNull().default(0), // 0=draft, 1=submitted, 2=cancelled
  // Reference to source document (e.g. Purchase Invoice, Purchase Order)
  referenceModule: text("reference_module"),
  referenceId: text("reference_id"),
  // Totals
  totalQty: real("total_qty").notNull().default(0),
  totalAmount: real("total_amount").notNull().default(0),
  // Audit
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at"),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  gr_company_date_idx: index("gr_company_date_idx").on(table.companyId, table.postingDate),
  gr_company_party_idx: index("gr_company_party_idx").on(table.companyId, table.partyId),
}));

// ============================================================================
// goods_receipt_items — รายการสินค้าในใบรับสินค้า
// ============================================================================
export const goodsReceiptItems = sqliteTable("inventory_goods_receipt_items", {
  id: text("id").primaryKey(), // ULID
  goodsReceiptId: text("goods_receipt_id").notNull(),
  purchaseOrderId: text("purchase_order_id"),
  purchaseOrderItemId: text("purchase_order_item_id"),
  itemId: text("item_id").notNull(),
  warehouseId: text("warehouse_id"),
  qty: real("qty").notNull().default(0),
  rate: real("rate").notNull().default(0),
  amount: real("amount").notNull().default(0),
  landedCostAmount: real("landed_cost_amount").notNull().default(0),
  remarks: text("remarks"),
}, (table) => ({
  gri_receipt_idx: index("gri_receipt_idx").on(table.goodsReceiptId),
  gri_po_line_idx: index("gri_po_line_idx").on(table.purchaseOrderId, table.purchaseOrderItemId),
}));

// Type exports
export type GoodsReceipt = typeof goodsReceipts.$inferSelect;
export type NewGoodsReceipt = typeof goodsReceipts.$inferInsert;
export type GoodsReceiptItem = typeof goodsReceiptItems.$inferSelect;
export type NewGoodsReceiptItem = typeof goodsReceiptItems.$inferInsert;
